module.exports = __webpack_public_path__ + "assets/img/tab1.a54c0121.png";